import type { BrandImageTag } from '@mondaygpt/constants'

/**
 * Per-archetype copy for the FocusStep. Describes the BUSINESS's primary
 * content type — distinct from the legacy `BRAND_IMAGE_TAG_META` copy in
 * `@mondaygpt/constants`, which describes uploaded image categories.
 */
export const CONTENT_FOCUS_OPTIONS: ReadonlyArray<{
  id: BrandImageTag
  label: string
  blurb: string
  uploadCopy: string
}> = [
  {
    id: 'products',
    label: 'Our products',
    blurb: 'Ecommerce, retail, food. The thing we sell is the star.',
    uploadCopy: 'Drop in a few product photos so Taka can feature them.',
  },
  {
    id: 'people',
    label: 'Faces & people',
    blurb: 'Realtors, trainers, coaches. Our face IS the brand.',
    uploadCopy: 'Drop in a headshot or two so Taka can put your face in posts.',
  },
  {
    id: 'other',
    label: 'Our service or work',
    blurb: 'Services without a single product or face.',
    uploadCopy: 'Drop in some lifestyle shots, locations, or work in progress.',
  },
]

const PRODUCT_SIGNALS = [
  'shop',
  'store',
  'product',
  'retail',
  'ecommerce',
  'commerce',
  'sell',
  'merchandise',
  'apparel',
  'goods',
  'collection',
  'cosmetics',
  'fashion',
  'food',
  'restaurant',
  'cafe',
  'bakery',
  'menu',
]
const PERSON_SIGNALS = [
  'realtor',
  'agent',
  'coach',
  'trainer',
  'consultant',
  'therapist',
  'advisor',
  'freelance',
  'photographer',
  'instructor',
  'broker',
  'dentist',
  'lawyer',
  'doctor',
  'tutor',
  'mentor',
  'speaker',
  'creator',
  'influencer',
]

export function classifyContentFocus(input: {
  industry?: string
  description?: string
  keywords?: string[]
}): BrandImageTag {
  const text = [input.industry, input.description, ...(input.keywords ?? [])]
    .filter(Boolean)
    .join(' ')
    .toLowerCase()
  const productScore = PRODUCT_SIGNALS.filter(s => text.includes(s)).length
  const personScore = PERSON_SIGNALS.filter(s => text.includes(s)).length
  if (personScore >= 2 || (personScore > 0 && personScore >= productScore)) return 'people'
  if (productScore >= 2) return 'products'
  return 'other'
}
